// import only the bits of semver we need
import semverValid from 'semver/functions/valid'
import semverGte from 'semver/functions/gte'
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { logException } from 'utils/errors'
import { Paths } from 'utils/paths'
import { currentSemver } from 'selectors/wprsnpr'
import { usernameSelector } from 'selectors/users'
import SmartLink from 'components/Elements/SmartLink'

import "stylesheets/components/semver_indicator.scss"

class SemverIndicator extends React.PureComponent {
  static propTypes = {
    semver: PropTypes.string.isRequired,
    nolink: PropTypes.bool,
    boardName: PropTypes.string.isRequired,
    onUpdateClicked: PropTypes.func,
  }

  upToDate() {
    const { semver, currentSemver } = this.props

    try {
      // these methods throw if given invalid semver
      return semverValid(semver) && semverGte(semver, currentSemver)
    } catch(error) {
      // tell us something happened
      logException(error)
      // but don't crash the front-end
      return false
    }
  }

  renderSemver() {
    const { semver } = this.props
    return semver ? `v${ semver }` : "Firmware Unknown"
  }

  renderUpToDate() {
    return <span className="semver-indicator up-to-date">
      <i className="fas fa-circle-check"></i> { this.renderSemver() }
    </span>
  }

  renderNeedsUpdate() {
    const
      { username, boardName, onUpdateClicked } = this.props,
      updateFirmwarePath = Paths.update_wipper({ username, boardName })

    return <span className="semver-indicator">
      <span className="needs-update"><i className="fas fa-circle-exclamation"></i> { this.renderSemver() }</span>
      <SmartLink to={ onUpdateClicked || updateFirmwarePath } className="update-link">
        <i className="fas fa-rotate"></i> Update
      </SmartLink>
    </span>
  }

  render() {
    return this.upToDate()
      ? this.renderUpToDate()
      : this.renderNeedsUpdate()
  }
}

const mapState = state => ({
  username: usernameSelector(state),
  currentSemver: currentSemver(state)
})

export default connect(mapState)(SemverIndicator)
